export default "__VITE_ASSET__BgH3QW4h__"